import { faTrash, IconDefinition } from '@fortawesome/free-solid-svg-icons';
import React, { useContext, useState } from 'react';
import { CustomButton } from './CustomButton';
import { InfoModal } from './InfoModal';
import { Role } from '../utils/Enums/Roles';
import { AuthContext } from '../context/AuthContext';
import {Form} from "react-bootstrap";
import {useTranslation} from "react-i18next";
import {CustomSelect} from "./CustomSelect";

export const DeleteActionComponent = ({
    onAction,
    disabled = false,
    disabledReason,
    actionText,
    translatedActionText,
    deleteButtonText,
    accessActionRoles,
    actionIcon,
    hideModal,
    comment,
    setComment,
    setDeleteReason
}: {
    onAction: () => void;
    disabled?: boolean;
    disabledReason?: string;
    actionText?: string;
    translatedActionText?: string;
    deleteButtonText?: string;
    accessActionRoles?: Role[];
    actionIcon?: IconDefinition;
    hideModal?: boolean;
    comment?: string;
    setComment?: (comment: string) => void;
    setDeleteReason?: (comment: string) => void;
}) => {
    const { t } = useTranslation('translation', { keyPrefix: 'common' });

    const [showModal, setShowModal] = useState(false);
    const { hasPermission } = useContext(AuthContext);
    const [deleteText, setDeleteText] = useState(deleteButtonText);

    return (
        <>
            <span title={disabled ? disabledReason : undefined}>
            <CustomButton
                icon={actionIcon ?? faTrash}
                iconClass='fa-fw'
                onClick={() => { if (!disabled) { hideModal ? onAction() : setShowModal(true); } }}
                className='color-main'
                disabled={disabled || (accessActionRoles && !hasPermission([...accessActionRoles, Role.ADMIN]))}
            />
            </span>
            <InfoModal
                text={actionText}
                translatedText={translatedActionText}
                isDisabled={comment!=undefined && (setDeleteReason == undefined || deleteText === "delete") ? comment.length < 1 : false}
                show={showModal}
                buttonText={deleteText}
                onHide={async (isDelete: boolean) => {
                    setShowModal(false);
                    if (isDelete && !disabled) {
                        await onAction();
                    }
                    if(setComment!=undefined){
                        setComment("");
                    }
                }}
            >
                {setDeleteReason &&
                <CustomSelect
                    customClass={'mb-3'}
                    updateValue={(value) => {setDeleteReason(value); setDeleteText(value)}}
                    itemsToShow={['scrap', 'delete']}
                />}
                {(setComment && (setDeleteReason == undefined || deleteText === "delete")) && <><span className='w-100 text-secondary'>{`*${t('commentRequired')}`}</span>
                <Form.Control
                    placeholder={t('comment')}
                    name={'comment'}
                    onChange={(e) => setComment(e.currentTarget.value)}
                    value={comment}
                /></>}
            </InfoModal>
        </>
    );
};
